/**
 * A telemedicine visit moves through distinct states. This module
 * centralizes that state.
 */

import Diode from 'diode'
import { Patient, Advisor, Visit, Flags } from './records'
import { assoc, get } from 'sprout-data'
import _reject from 'lodash/reject'

const emitter = Diode()

let state = {
  visit: Visit(),
  patient: Patient(),
  advisor: Advisor(),
  flags: Flags(),
}

export function getState(keyPath) {
  return keyPath ? get(state, keyPath.split('.')) : state
}

export function setState(params) {
  state = {
    visit: Visit(state.visit, params.visit),
    patient: Patient(state.patient, params.patient),
    advisor: Advisor(state.advisor, params.advisor),
    flags: Flags(state.flags, params.flags),
    flipflop_features: state.flipflop_features || params.flipflop_features,
    lastQualityCheckSentAt: params.lastQualityCheckSentAt || state.lastQualityCheckSentAt,
  }

  emitter.publish(state)
}

export function setKeyPath(key, value) {
  setState(assoc(state, key.split('.'), value))
}

export function append(key, value) {
  setKeyPath(key, getState(key).concat(value))
}

export function reject(key, pattern) {
  setKeyPath(key, _reject(getState(key), pattern))
}

export function listen(callback, scope) {
  emitter.listen(callback, scope)
}

export function ignore(callback, scope) {
  emitter.ignore(callback, scope)
}

export function reset() {
  state = {}
  setState({})
}

export default {
  getState,
  setState,
  setKeyPath,
  append,
  reject,
  listen,
  ignore,
  reset
}
